import FormLabel from "../../../../../../packages/design-system/src/FormLabel";
import * as React from 'react';
export default {
  FormLabel,
  React
};